import { Card,Row,Col,Descriptions } from "antd";
import { useState } from "react";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
export default function AcademicUnitView({Campus}) {

    const [activeTabKey,setActiveTabKey]=useState("infoBasic")
    const location=useLocation()
    const academicUnit=location.state?.academicUnit;

    const convertDateToOnlyDate=(date)=> {
        const newDate=new Date(date);
        return newDate.toLocaleDateString();
    }
    function convertDateToTime(date) {
        const newDate=new Date(date);
        return newDate.toLocaleTimeString();
    }
    const tabList=[
        {
            key:"infoBasic",
            tab:"información basica",
        },
        {
            key:"status",
            tab:"Estado",
        },
    ]

      const statusData=()=>{
        return (
        <Descriptions bordered>
            <Descriptions.Item label="Estado">{academicUnit.status ? "Activo": "Inactivo"}</Descriptions.Item>
        </Descriptions>);
      }
      const infoBasicData=()=>{
        return (
        <Descriptions bordered>
            <Descriptions.Item span={3} label="Nombre">{academicUnit.name}</Descriptions.Item>
            <Descriptions.Item span={3} label="Localización">{academicUnit.location}</Descriptions.Item>
            <Descriptions.Item span={3} label="Fecha de creacion">{convertDateToOnlyDate(academicUnit.createdAt)}</Descriptions.Item>
            <Descriptions.Item span={3} label="Hora de creacion">{convertDateToTime(academicUnit.createdAt)}</Descriptions.Item>
        </Descriptions>
        )
      }
    const contentlist={
        infoBasic: infoBasicData(),
        status: statusData()
    }

    const onTabChange=(key)=>{
        setActiveTabKey(key)
    }

    return(
    <>
    {console.log(academicUnit)}
    <Card
    style={{margin:10}}
    title={"Información de la unidad academica"}
    >
        <Row gutter={16}>
            <Col span={16}>
                <Card
                tabList={tabList}
                activeTabKey={activeTabKey} 
                onTabChange={onTabChange}
                >
                    {contentlist[activeTabKey]}
                </Card>
            </Col>
            <Col span={8}>
                <Card>
                </Card>
            </Col>
        </Row>
    </Card>
    </>
    )
}